import styled from 'styled-components';
import { Slider } from '@bynder/design-system';

type SliderSize = 's' | 'm' | 'l';

export const VolumeSlider = styled(Slider)<{ size: SliderSize }>`
    min-width: ${({ size }) => {
        // eslint-disable-next-line no-nested-ternary
        return size === 's' ? '156px' : size === 'm' ? '205px' : '260px';
    }};
`;
